module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II7.cc5e60c1.png";